/*
   TRIAL & FLORA — botanical plate renderer for Shopify product pages.

   Bridges real store products to the static-site plate engine: builds a
   plate-engine product object {id, genus, artStyle, name, caption, plateNo}
   from data attributes and lets TF_ART (trial-flora-art.js, loaded globally
   from theme.liquid) draw SVG into every [data-tf-plate] element.

   Included by both the studies section and the media-gallery fallback, so it
   may be evaluated twice on one page — the window guard makes the second
   evaluation a no-op (a top-level const here would throw, see TF_ART gotcha).
*/
(function () {
  if (window.__tfPlatesInit) return;
  window.__tfPlatesInit = true;

  var GENERA = ["hoya", "epipremnum", "philodendron", "dioscorea"];

  /* Title keywords → art-engine style keys (LEAF_STYLES / GENUS_COMP in
     trial-flora-art.js). First match wins; unknown keys fall back safely
     inside the engine, so these only need to catch the recognizable names. */
  var STYLE_RULES = {
    hoya: [
      [/kerrii|sweetheart/, "kerrii"],
      [/linearis/, "linearis"],
      [/callistophylla|crocodile|finlaysonii/, "callisto"],
      [/krimson|tricolor|rubra/, "krimson"],
      [/silver|splash|snow|dust|freckle|mathilde/, "splash"],
      [/bella/, "bella"],
    ],
    epipremnum: [
      [/marble|queen/, "marble"],
      [/njoy|n'joy|pearls|jade/, "njoy"],
      [/cebu|baltic/, "cebu"],
      [/teruno|fanfare/, "teruno"],
      [/skeleton/, "skeleton"],
      [/global/, "global"],
    ],
    philodendron: [
      [/birkin/, "birkin"],
      [/micans/, "micans"],
      [/gloriosum/, "gloriosum"],
      [/pink princess|\bppp\b/, "ppp"],
      [/white knight|white wizard/, "whiteknight"],
    ],
    dioscorea: [
      [/discolor/, "discolor"],
      [/sylvatica/, "sylvatica"],
    ],
  };
  var STYLE_DEFAULT = {
    hoya: "hoyaPlain",
    epipremnum: "marble",
    philodendron: "gloriosum",
    dioscorea: "elephantipes",
  };

  function detectGenus(title) {
    var t = title.toLowerCase();
    for (var i = 0; i < GENERA.length; i++) {
      if (t.indexOf(GENERA[i]) !== -1) return GENERA[i];
    }
    return "hoya";
  }

  function deriveStyle(genus, title) {
    var rules = STYLE_RULES[genus] || [];
    var t = title.toLowerCase();
    for (var i = 0; i < rules.length; i++) {
      if (rules[i][0].test(t)) return rules[i][1];
    }
    return STYLE_DEFAULT[genus] || "hoyaPlain";
  }

  /* "Lacunosa Gold Lunar_A (Freebie)" → "hoya lacunosa gold lunar" */
  function cleanCaption(title, genus) {
    var t = title
      .toLowerCase()
      .replace(/\(.*?\)/g, " ")            /* parentheticals: (freebie), (rooted) */
      .replace(/[_-][a-z]\b/g, " ")        /* specimen suffixes: _a, -b */
      .replace(/\bin\s*\d.*$/g, " ")       /* trailing pot sizes: in 3" swp */
      .replace(/\bfreebie\b/g, " ")
      .replace(/[<>&"']/g, "")
      .replace(/\s+/g, " ")
      .trim();
    if (t && t.indexOf(genus) === -1) t = genus + " " + t;
    return t || genus;
  }

  function toRoman(n) {
    var map = [[40, "XL"], [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"]];
    var s = "";
    for (var i = 0; i < map.length; i++) {
      while (n >= map[i][0]) {
        s += map[i][1];
        n -= map[i][0];
      }
    }
    return s;
  }

  function plateNoFor(handle) {
    var h = Math.abs(TF_ART.hashCode("plate-no:" + handle));
    return toRoman((h % 40) + 1);
  }

  function render(root) {
    if (typeof TF_ART === "undefined") return false;
    var nodes = (root || document).querySelectorAll("[data-tf-plate]:not([data-tf-plate-done])");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var handle = el.getAttribute("data-handle") || "specimen";
      var title = (el.getAttribute("data-title") || "Specimen").replace(/[<>&"]/g, "");
      var genus = (el.getAttribute("data-genus") || "").toLowerCase();
      if (GENERA.indexOf(genus) === -1) genus = detectGenus(title);
      var variant = parseInt(el.getAttribute("data-variant") || "0", 10) || 0;
      var product = {
        id: handle,
        genus: genus,
        artStyle: deriveStyle(genus, title),
        name: title,
        caption: cleanCaption(title, genus),
        plateNo: plateNoFor(handle),
      };
      el.innerHTML = TF_ART.plate(product, variant, "", { bleed: el.hasAttribute("data-bleed") });
      el.setAttribute("data-tf-plate-done", "");
    }
    return true;
  }

  /* TF_ART is a deferred classic script that runs before this one in document
     order; the retry loop covers any exotic loading order anyway. */
  var tries = 0;
  function boot() {
    if (render() || tries++ > 40) return;
    setTimeout(boot, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* theme editor re-renders sections without a page load */
  document.addEventListener("shopify:section:load", function (e) {
    render(e.target);
  });
})();
